import { CurrencyUtil } from "@eres/core";
import { NullableFormValue, ValueConverter } from "../index";


class CurrencyConverter implements ValueConverter<string, string> {
	toData( text: NullableFormValue<string, string> ): NullableFormValue<string, string> {
		if ( text != undefined ) {
			let value = CurrencyUtil.convertCurrencyToValue( text );
			return value ? value + "" : "";
		}
		return "";

	}

	fromData( data: NullableFormValue<string, string> ): NullableFormValue<string, string> {
		let replace = data ? data + "".replace( ",", "" ) : "";
		let value = Number.parseFloat( replace );
		if ( isNaN( value ) ) return undefined;
		return CurrencyUtil.toFormattedCurrency( value ) + "";
	};
}

const Converter = new CurrencyConverter();
export default Converter;
